import { useEffect, useState } from "react";
import client from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { money, onboardingLink } from "../lib/helpers";
import { Storefront, TrendUp, Copy, ShareNetwork } from "@phosphor-icons/react";
import { Button } from "./ui/button";
import { toast } from "sonner";

export default function ReferralTally() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  const slug = user?.slug;
  const link = onboardingLink("photographer", slug);

  useEffect(() => {
    client.get("/pay/commissions/summary").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const copyLink = () => { navigator.clipboard.writeText(link); toast.success("Booking link copied"); };
  const shareLink = async () => {
    if (navigator.share) { try { await navigator.share({ title: "Book a Reelty shoot", url: link }); } catch (e) { /* dismissed */ } }
    else copyLink();
  };

  if (!data) return null;

  const earned = data.month_total > 0;
  return (
    <div data-testid="referral-tally"
      className="mb-6 rounded-md border border-[#B08D57]/40 bg-gradient-to-r from-[#4A0000] to-[#5C1A1A] text-white p-5 flex items-start justify-between gap-4 shadow-premium">
      <div className="flex items-center gap-3">
        <div className="h-11 w-11 rounded-full bg-[#B08D57]/20 border border-[#B08D57]/40 flex items-center justify-center">
          <Storefront size={22} weight="fill" className="text-[#B08D57]" />
        </div>
        <div>
          <p className="text-[#B08D57] eyebrow text-xs mb-0.5">{data.month_label} link commissions</p>
          {earned ? (
            <div data-testid="referral-tally-text">
              <p className="text-sm text-white/90 whitespace-nowrap leading-tight">You've earned <span className="font-display text-2xl align-middle text-white">{money(data.month_total)}</span></p>
              <p className="text-sm text-white/90 whitespace-nowrap leading-tight">in link commissions this month{data.month_count ? ` across ${data.month_count} booking${data.month_count > 1 ? "s" : ""}` : ""}. 🎉</p>
            </div>
          ) : (
            <p className="text-sm text-white/90" data-testid="referral-tally-text">
              Share your booking page to start earning 10% link commissions — nothing yet this month.
            </p>
          )}
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        {data.all_time_total > 0 && (
          <div className="text-right hidden lg:block mr-1" data-testid="referral-tally-alltime">
            <p className="text-[#B08D57] eyebrow text-xs mb-0.5 flex items-center gap-1 justify-end"><TrendUp size={13} weight="bold" />All time</p>
            <p className="font-display text-xl">{money(data.all_time_total)}</p>
          </div>
        )}
        {slug && (
          <>
            <Button data-testid="referral-copy-link" onClick={copyLink} size="sm" className="bg-[#B08D57] hover:bg-[#9A7A4A] text-[#1A1A1A]"><Copy size={15} className="mr-1.5" weight="bold" />Copy link</Button>
            <Button data-testid="referral-share-link" onClick={shareLink} size="sm" variant="outline" className="border-white/30 text-white hover:bg-white/10 bg-transparent"><ShareNetwork size={15} className="mr-1.5" weight="bold" />Share</Button>
          </>
        )}
      </div>
    </div>
  );
}
